import { ExpandedRowTable } from "@/molecules/ExpandedRowTable"
import { AGENT_AI_DISCOVERY_DRAWER_ID } from "@/organisms/Drawers/const"
import { useDrawer } from "@/organisms/Drawers/hooks/useDrawer"
import { getAgentsAi } from "@/pages/DiscoveryPage/application/ai-discovery/useAiDiscovery.select"
import { getColumnsTab } from "./getColumnsTab"

import styles from "./ExpandedRowAiPoliciesTab.module.scss"

export const ExpandedRowAiPoliciesTab = (props: {
  id: string
  agentsDescription: string
  agents: ReturnType<ReturnType<typeof getAgentsAi>>["data"]
}) => {
  const { open } = useDrawer(AGENT_AI_DISCOVERY_DRAWER_ID)

  return (
    <div className={styles.container}>
      <span>{props.agentsDescription}</span>
      <ExpandedRowTable
        showHeader
        columns={getColumnsTab()}
        dataSource={props.agents}
        locale={{ emptyText: "No agents available" }}
        onRow={(record) => ({
          onClick: () => {
            open({
              record: {
                id: record.id,
                meta: {
                  __defaultActiveKey: "aiPolicy",
                  policyId: props.id
                }
              }
            })
          }
        })}
      />
    </div>
  )
}
